module.exports = __webpack_public_path__ + "img/hnz-logo.39a52f26.png";